export const BACKUP_COLOR_VALUES = [
  'red-500',
  'orange-500',
  'amber-500',
  'yellow-500',
  'lime-500',
  'green-500',
  'teal-500',
  'cyan-500',
  'blue-500',
  'violet-500',
  'pink-500',
  'slate-500',
] as const;

export type IBackupColor = (typeof BACKUP_COLOR_VALUES)[number];

export const BACKUP_COLORS: { value: IBackupColor; className: string }[] = [
  { value: 'red-500', className: 'bg-red-500' },
  { value: 'orange-500', className: 'bg-orange-500' },
  { value: 'amber-500', className: 'bg-amber-500' },
  { value: 'yellow-500', className: 'bg-yellow-500' },
  { value: 'lime-500', className: 'bg-lime-500' },
  { value: 'green-500', className: 'bg-green-500' },
  { value: 'teal-500', className: 'bg-teal-500' },
  { value: 'cyan-500', className: 'bg-cyan-500' },
  { value: 'blue-500', className: 'bg-blue-500' },
  { value: 'violet-500', className: 'bg-violet-500' },
  { value: 'pink-500', className: 'bg-pink-500' },
  { value: 'slate-500', className: 'bg-slate-500' },
];

export const BACKUP_COLOR_MAP: Record<IBackupColor, string> = BACKUP_COLORS.reduce(
  (acc, { value, className }) => ({ ...acc, [value]: className }),
  {} as Record<IBackupColor, string>,
);
